// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".qsAhTWbET5X1qO {\n  float: left;\n  border-left: 1px solid var(--dynamic-text-transparent);\n  height: 16px;\n  margin: 8px 8px 12px 4px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boardHeaderButtonDivider": "qsAhTWbET5X1qO"
};
export default ___CSS_LOADER_EXPORT___;
